import React, { useState } from "react"

import EmailInput from "../ui-components/EmailInput"
import SubmitButton from "../ui-components/SubmitButton"
import Row from "../ui-components/Row"
import Col from "../ui-components/Col"
import { RequestPasswordToken } from "../apis/UserSessionAPI"

import style from "./RequestUserPasswordToken.module"

export default function RequestUserPasswordToken() {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [state, setState] = useState({
    email: "",
    error: false,
    tokenSent: false,
    submitDisabled: false,
  })

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleEmailChanged(event) {
    setState({ ...state, email: event.target.value })
  }

  function handleSubmit(event) {
    event.preventDefault()

    setState({ ...state, tokenSent: false, error: false, submitDisabled: true })

    RequestPasswordToken(state.email)
      .then((res) => {
        setState({ ...state, tokenSent: true, submitDisabled: false })
      })
      .catch((error) => {
        setState({ ...state, error: true, submitDisabled: false })
      })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div>
      <div className={style.title}>
        {I18n.t("pages.user_session.passwords.forgot_password")}
      </div>

      <div className={style.desc}>
        {I18n.t("pages.user_session.passwords.forgot_password_details")}
      </div>

      <form className={style.input} onSubmit={handleSubmit}>
        <Row>
          <Col className="col-sm-12">
            <EmailInput
              name="user_email"
              value={state.email}
              placeholder={I18n.t("pages.user_session.user.email")}
              onChange={handleEmailChanged}
            />
          </Col>
        </Row>

        {state.error && (
          <Row>
            <Col className="col-sm-12">
              <div className="alert alert-danger">
                {I18n.t("pages.user_session.passwords.cannot_change_password")}
              </div>
            </Col>
          </Row>
        )}

        {state.tokenSent && (
          <Row>
            <Col className="col-sm-12">
              <div className="alert alert-success">
                {I18n.t("pages.user_session.passwords.resent_email_sent")}
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col className="col-sm-12">
            <SubmitButton
              className={`btn btn-primary ${style.submit}`}
              disabled={state.submitDisabled}
              value={I18n.t("pages.user_session.passwords.send_instructions")}
            />
          </Col>
        </Row>
      </form>
    </div>
  )
}
